<template>
  <div class="audience-product-wrapper" id="audiences">
    <div class="block-heading-font-style">MikMak Video Shopper Audiences</div>
    <div class="block-subheading-font-style">Generate and own qualified audiences from social video. Take immediate action on these audiences by leveraging our Facebook integration or directly adding them to your CRM.</div>

    <div class="audience-product-block">
      <span class="audience-product-block-item">
        <img src="./social-audience-right.png" class="audience-product-image">
        <div class="audience-product-block-header">
          Social Audiences
        </div>
        <div class="audience-product-block-subheader">
          Build qualified audiences through engagement
        </div>
        <div class="audience-product-block-body">
          MikMak Attach qualifies your leads from social video views and turns them into new custom audiences for you to take immediate action on.
        </div>
      </span>

      <span class="audience-product-block-item">
        <img src="./direct-audience-left.png" class="audience-product-image">
        <div class="audience-product-block-header">
          Direct Audiences
        </div>
        <div class="audience-product-block-subheader">
          Easily create &amp; own direct audiences
        </div>
        <div class="audience-product-block-body">
          MikMak Attach converts social video views into email addresses and cell phone numbers that your brand can add to its CRM database.
        </div>
      </span>
    </div>

    <a href="#contact-footer" class="audience-product-block-desktop-button" v-on:click="logCtaClick">
      Act on your Audiences
    </a>

    <a href="#contact-footer" v-on:click="logCtaClick" class="mobile-cta-button" v-bind:class="[shouldShowMainCta ? 'mobile-cta-button-visible' : 'mobile-cta-button-hidden']">
      Act on your Audiences
    </a>
  </div>
</template>

<script>

  import productScrollHelper from './productScrollHelper'
  import eventDispatcher from '../../events/dispatch'

  export default {
    mounted() {
      this.scrollListener()
    },
    data() {
      return {
        shouldShowMainCta: undefined
      }
    },
    methods: {
      logCtaClick() {
        if (!window.mmProductInterests) window.mmProductInterests = []
        window.mmProductInterests.push('Clicked Learn More about Audiences')

        eventDispatcher('requestDemoClicked', {
          product: 'audiences'
        })

        this.resetScroll()
      },
      resetScroll() {
        setTimeout(() => {
          window.scrollBy(0, -48)
        }, 10)
      },
      updateShouldShowMainCta(shouldShow) {
        if (shouldShow && !this.shouldShowMainCta) this.shouldShowMainCta = true
        if (!shouldShow && this.shouldShowMainCta) this.shouldShowMainCta = false
      },
      scrollListener() {
        let self = this
        $(window).scroll(function(){
          let shouldShowMainCta = productScrollHelper.scrollListener('audiences')
          self.updateShouldShowMainCta(shouldShowMainCta)
        });
      },
    },
    computed: {},
    watch: {}
  }
</script>

<style scoped>

  .audience-product-wrapper {
    padding: 24px;
    background: white;
  }

  .mobile-cta-button {
    display: none;
  }

  .mobile-cta-button-hidden,
  .mobile-cta-button-visible {
    transition: ease-in-out 0.225s;
    background: #409dd4;
    background: #00a9bc;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00a9bc', endColorstr='#00bfbd',GradientType=1 );
    position: fixed;
    left: 0;
    right: 0;
    text-align: center;
    padding: 16px;
    color: white;
    font-weight: lighter;
    z-index: 2;
    text-decoration: none;
  }

  @media only screen and (max-width: 650px) {
    .mobile-cta-button {
      display: block;
    }
    .mobile-cta-button-visible {
      bottom: 0;
    }
    .mobile-cta-button-hidden {
      bottom: -500px;
    }
  }

  .audience-product-block {
    display: block;
    white-space: nowrap;
  }

  .audience-product-block-item {
    display: inline-block;
    width: 49%;
    text-align: center;
    white-space: normal;
  }

  @media only screen and (max-width: 650px) {
    .audience-product-block-item {
      display: block;
      width: 100%;
      text-align: center;
      white-space: normal;
    }
  }

  .audience-product-image {
    width: 300px;
    margin: 24px;
    margin-top: 72px;
  }

  .audience-product-block-desktop-button {
    background: #409dd4;
    background: #00a9bc;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00a9bc', endColorstr='#00bfbd',GradientType=1 );
    color: white;
    font-size: 22px;
    width: 400px;
    text-align: center;
    padding: 8px;
    border-radius: 3px;
    display: block;
    cursor: pointer;
    box-shadow: 0px 2px 6px #00000024;
    font-weight: lighter;
    text-decoration: none;
    margin: 24px auto;
    margin-top: 72px;
    letter-spacing: 1px;
  }

  .audience-product-block-header {
    font-family: 'Work Sans', sans-serif;
    text-transform: uppercase;
    display: block;
    font-size: 32px;
    letter-spacing: 2px;
    color: #a5a5a5;
    text-align: center;
    font-weight: normal;
  }

  @media only screen and (max-width: 650px) {
    .audience-product-block-header {
      font-size: 28px;
    }
  }

  .audience-product-block-body {
    font-size: 14px;
    width: 275px;
    margin: 12px auto;
    font-family: 'Work Sans', sans-serif;
    color: #333;
    font-size: 14px;
  }

  @media only screen and (max-width: 650px) {
    .audience-product-block-body {
      width: 90%;
      margin: 12px auto;
    }
  }

  .audience-product-block-body em {
    font-style: normal;
    font-weight: bold;
  }

  @media only screen and (max-width: 650px) {
    .audience-product-block-desktop-button {
      display: none;
    }
  }

  .audience-product-block-subheader {
    color: #409dd4;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 14px;
    margin: 12px;
  }


</style>



// WEBPACK FOOTER //
// AudiencesProductComponent.vue?0c298bca